import React from "react";
import { makeStyles } from "@mui/styles";
import lineFooter from "../../../assets/home/line-footer.png";
import lineFooterMobei from "../../../assets/home/line-footer2.png";
import logoMb from "../../../assets/logo/logo-mb.png";
import { iconSvg } from "src/assets/iconsSvg";
import { colors } from "src/colors/colors";
import ContainerMain from "src/commonStyles/container/containerMain/containerMain";
import { FontSize } from "src/const/font";
import { MB_LINK } from "src/const";
import { handlePhoneCall } from "src/utils/checkMobileWebView";
const useStyles = makeStyles((theme) => {
  return {
    containerFooterDad: {
      background: colors.white,
      paddingBottom: "24px",
    },
    containerLine: {
      display: "flex",
    },
    lineItem: {
      width: "20%",
    },
    imageLineFooter: {
      width: "100%",
      marginBottom: "30px",
    },
    iconContactContainer: {
      display: "flex",
      cursor: "pointer",
      [theme.breakpoints.down("md")]: {
        marginBottom: "16px",
        fontSize: FontSize.sub.default,
      },
    },
    iconContact: {
      minWidth: "40px",
      [theme.breakpoints.down("md")]: {},
    },
    mb16: {
      marginBottom: "16px",
    },
    containerFooter: {
      display: "flex",
      justifyContent: "space-between",
      padding: "0 16px",
      alignItems: "flex-end",
      [theme.breakpoints.down("lg")]: {
        display: "block",
      },
      [theme.breakpoints.down("sm")]: {
        padding: "0 8px",
      },
    },
    logoContainer: {
      width: "15%",
      display: "flex",
      justifyContent: "flex-end",
      [theme.breakpoints.down("md")]: {
        marginBottom: "18px",
        width: "100%",
        display: "block",
      },
    },
    locationContact: {
      width: "80%",
      [theme.breakpoints.down("lg")]: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
      },
      [theme.breakpoints.down("md")]: {
        alignItems: "flex-start",
        width: "100%",
      },
    },
    logoMb: {
      width: "158px",
      height: "80px",
      objectFit: 'contain',
      [theme.breakpoints.down("sm")]: {
        width: "86px",
        height: "43px",
      },
    },
    listIconSocailMedia: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "27px",
      width: "80%",
    },
    followMb: {
      fontSize: "14px",
      lineHeight: "20px",
      color: "#666666",
    },
    containerRight: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-end",
      [theme.breakpoints.down("md")]: {
        alignItems: "center",
      },
    },
    contianerContact: {
      display: "flex",
      justifyContent: "space-between",
      maxWidth: "650px",
      width: "100%",
      [theme.breakpoints.down("md")]: {
        display: "block",
      },
    },
    contentLeft: {
      width: "70%",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-end",
      [theme.breakpoints.down("lg")]: {
        width: "100%",
        marginBottom: "24px",
      },
      [theme.breakpoints.down("md")]: {
        display: "block",
      },
    },
    lineDesktop: {
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },
    lineMobei: {
      display: "none",
      [theme.breakpoints.down("sm")]: {
        display: "block",
      },
    },
  };
});
const webViewMbageas = () => {
  window.open("https://www.mblife.vn/");
};
const mailTo = () => {
  window.open("mailto:dvkh@mblife.vn");
};
const phoneNumber = () => {
  handlePhoneCall("(+84) 24 2229 8888");
};
const FooterHome = () => {
  const classes = useStyles();
  return (
    <div className={`${classes.containerFooterDad} footer`}>
      <div className={classes.lineMobei}>
        <img src={lineFooterMobei} alt="" className={classes.imageLineFooter} />
      </div>
      <ContainerMain>
        <div className={classes.lineDesktop}>
          <img src={lineFooter} alt="" className={classes.imageLineFooter} />
        </div>
        <div className={classes.containerFooter}>
          <div className={classes.contentLeft}>
            <a href={MB_LINK} className={classes.logoContainer}>
              <img src={logoMb} alt="" className={classes.logoMb} />
            </a>
            <div className={classes.locationContact}>
              <div
                className={`${classes.iconContactContainer} ${classes.mb16}`}
              >
                <div className={classes.iconContact}>{iconSvg.location}</div>{" "}
                  Tầng 15, Tòa nhà MB - Số 21 Cát Linh, Phường Ô Chợ Dừa, Thành phố Hà Nội
              </div>
              <div className={classes.contianerContact}>
                <div
                  className={`${classes.iconContactContainer}`}
                  onClick={webViewMbageas}
                >
                  <div className={classes.iconContact}>
                    {iconSvg.websiteIcon}
                  </div>
                  www.mblife.vn
                </div>
                <div className={classes.iconContactContainer} onClick={mailTo}>
                  <div className={classes.iconContact}>
                    {iconSvg.emailFooter}
                  </div>
                  dvkh@mblife.vn
                </div>
                <div
                  className={classes.iconContactContainer}
                  onClick={phoneNumber}
                >
                  <div className={classes.iconContact}>
                    {iconSvg.phoneTalkFooter}
                  </div>
                  (+84) 24 2229 8888
                </div>
              </div>
            </div>
          </div>
          <div className={classes.containerRight}>
            <div className={classes.followMb}>
              © 2020 MB Life. All rights reserved.
            </div>
          </div>
        </div>
      </ContainerMain>
    </div>
  );
};

export default FooterHome;
